import axios from '@/utils/intercept'

export const login = (param) => {
    return axios.post('/auth/authorize',param)
}

// 客户端授权
export const authorize = (params) => {
    return axios.get('/auth/authorize',{
        params,
        headers: {
            Authorization: `bearer ${localStorage.getItem('accessToken')}`
        }
    })
}
